'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchMoreLabel = () => /*#__PURE__*/_jsx(Small, {
  className: "p-x-4",
  style: {
    color: EERIE
  },
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "routing-ui.reassignment.searchForMoreUsersLabel"
  })
});
SearchMoreLabel.displayName = 'SearchMoreLabel';
export default SearchMoreLabel;